import { ShoppingCartService } from './../../../services/inventory/shopping-cart.service';
//Angular
import {
    Component, OnInit, ViewContainerRef, Input,
    Compiler, Inject, ViewChild, ElementRef, Output, EventEmitter
} from "@angular/core";
import { Subscription } from 'rxjs/Subscription';

//Services
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { CustomersCanvasService } from "../../../services/inventory/customerscanvas.service";


@Component({
    selector: "customer-canvas-widget",
    template: ""
})

export class CanvasWidgetComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            @Inject('isBrowser') private isBrowser: boolean
        ) { }


    @Input() parentWidgetData: any;

    ngOnInit() {
        if(!this.isBrowser)
            return;
            
        if (this.parentWidgetData != null) {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentWidgetData);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    }

    private createSubComponent(canvasWidgetComponent: any) {

        @Component({
            template: canvasWidgetComponent.TemplateHtml
        })

        class ChildComponent implements OnInit {

            @ViewChild('editorPage') editorPage: ElementRef;
            @ViewChild('approvePage') approvePage: ElementRef;
            @ViewChild('finishOrderPage') finishOrderPage: ElementRef;

            constructor
                (
                    @Inject('isBrowser') private isBrowser: boolean,

                    public canvasService: CustomersCanvasService,
                    private shoppingCartService: ShoppingCartService
                ) { }

            private pageIsInit: boolean = false;

            ngOnInit() { }

            // when want to finish design, to move to the second step
            finishDesign() {
                this.canvasService.getImagesLinks(this.editorPage, this.approvePage, this.finishOrderPage);
            }

            // when close a modal with canvas editor, set state to false, so from component we can know the modal is closed
            isCanvasModalOpened(isOpened: boolean) {
                this.canvasService.openNewProductInEditor();
                this.canvasService.setCanvasState(isOpened);
            }

            // when the product is successfully created and approved, and second step is done
            finishProductCustomization() {
                //If the product customization has been successfully completed.
                this.canvasService.finishProductCustomization()
                    .then(result => {
                        // set canvas response to a property in service, so it can be available to a parent component
                        this.shoppingCartService.setCustomizationCanvasData(result);
                        
                        //Saving hi-res output info.
                        this.canvasService.setupPageAfterProductCustomization(result, false);

                        /* Send notification to the service that we finished product customization, so from parent component we know it and can call method for adding to cart */
                        this.canvasService.setCanvasProductDesignState(true);
                        this.canvasService.openNewProductInEditor();
                    })
                    //If there was an error thrown while finishing the product customization.
                    .catch(error => {
                        this.canvasService.setupPageAfterProductCustomization(error, true);
                    });
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                layoutTheme.initSlider();

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/core/widget/canvas-widget.components.ts